/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PartnerPayloadBrokerType;

(function (PartnerPayloadBrokerType) {
  PartnerPayloadBrokerType["RETAIL_BROKER"] = "retail_broker";
  PartnerPayloadBrokerType["WHOLESALE_BROKER"] = "wholesale_broker";
  PartnerPayloadBrokerType["PARTNER"] = "partner";
  PartnerPayloadBrokerType["BROKER_NETWORK"] = "broker_network";
  PartnerPayloadBrokerType["OTHERS"] = "others";
})(PartnerPayloadBrokerType || (PartnerPayloadBrokerType = {}));